import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import toQueryString from './utils/toQueryString'

const RESOURCE_NAME = 'contratoGd'
const ENDPOINT = '/acl/contratos_gd'

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingContratoGdSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingContratoGdSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_CONTRATO_GD_SUCCESS = 'LOADING_CONTRATO_GD_SUCCESS'
export function loadingContratoGdSuccess(contratoGd) {
  return {
    type: LOADING_CONTRATO_GD_SUCCESS,
    contratoGd,
  }
}

export const DESTROYING_CONTRATO_GD_SUCCESS = 'DESTROYING_CONTRATO_GD_SUCCESS'
export function destroyingContratoGdSuccess(contratoId) {
  return {
    type: DESTROYING_CONTRATO_GD_SUCCESS,
    contratoId,
  }
}

export function fetchMultipleContratoGd(params = {}) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT + toQueryString(params)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchContratoGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createContratoGd(contratoGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT, 'POST', contratoGd).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateContratoGd(id, contratoGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`, 'PUT', contratoGd).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyContratoGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(`${ENDPOINT}/${id}`, 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

export function completeContratoGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}/complete`, 'POST').then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function undoContratoGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}/undo`, 'POST').then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function sazonalizacaoContratoGd(id, sazonalizacaoGdId, contratoGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      `${ENDPOINT}/${id}/sazonalizacao/${sazonalizacaoGdId}`,
      'POST',
      contratoGd
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function assignContratoGd(id, userId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}/assign/${userId}`, 'POST').then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

const contratoGd = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_CONTRATO_GD_SUCCESS: {
      const { contratoGd: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_CONTRATO_GD_SUCCESS:
      return state.delete(action.contratoId.toString())

    default:
      return state
  }
}

export default contratoGd
